<template>
  <div class="view-container">
    <div class="flex flex-col justify-around items-center">
      <div class="max-w-md w-full sm:w-1/2 lg:w-1/3 xl:w-1/3 flex flex-wrap content-center justify-center">

        <ValidationObserver class="w-full" ref="validator" v-slot="{ invalid }">
          <form @submit.prevent="submit()">

            <base-input :label-placeholder="$t('projects.table.code')"
                        :name="$t('projects.table.code')" autofocus
                        class="w-full" rules="required|alpha_dash"
                        v-model="project.code"/>

            <base-input :label-placeholder="$t('projects.table.name')"
                        :name="$t('projects.table.name')" autofocus
                        class="w-full" rules="required"
                        v-model="project.name"/>

            <base-multiselect
              :allow-empty="false"
              :input-label="$t('projects.table.client')"
              :loading="loadingSelect"
              :max-height="200"
              :options="clients"
              @search-change="$emit('requestClients', $event)"
              label="name"
              track-by="id"
              v-model="project.client"/>

            <base-multiselect
              :allow-empty="false"
              :custom-label="fullManagerName"
              :input-label="$t('projects.table.manager')"
              :max-height="200"
              :options="managers"
              :searchable="true"
              track-by="id"
              v-model="project.manager"/>

            <base-input :label-placeholder="$t('projects.table.estimation')"
                        :name="$t('projects.table.estimation')"
                        class="w-full" min="0"
                        rules="required|numeric"
                        type="number"
                        v-model="project.estimation"/>

            <base-input :label-placeholder="$t('projects.table.price')"
                        :name="$t('projects.table.price')"
                        class="w-full" rules="required|numeric"
                        type="number"
                        v-model="project.price"/>

            <base-multiselect
              :custom-label="customCurrencyLabel"
              :allow-empty="false"
              :input-label="$t('projects.table.currency')"
              :max-height="200"
              :options="currencies"
              @input="currencyChange"
              v-model="project.currency"/>

            <date-picker :input-label="$t('projects.table.start_date')"
                         :name="$t('projects.table.start_date')"
                         class="w-ful" rules="required"
                         :config="startDateConfig"
                         v-model="project.start_date"/>

            <date-picker :input-label="$t('projects.table.end_date')"
                         :name="$t('projects.table.end_date')" class="w-ful"
                         rules="required"
                         :config="endDateConfig"
                         v-model="project.end_date"/>

            <base-textarea :input-label="$t('projects.table.notes')"
                           :name="$t('projects.table.notes')"
                           class="w-full"
                           rows="7"
                           v-model="project.notes"/>

            <base-button :disabled="invalid" :loading="loading" button="filled" class="w-full mb-5 mt-2" color="success"
                         type="submit">
              {{ action }}
            </base-button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import DatePicker from "../DatePicker";
  import moment from "moment";

  export default {
    name: "ProjectDetailsComponent",
    components: {
      DatePicker
    },
    props: {
      project: {
        type: Object,
        required: true
      },
      managers: {
        type: Array,
        required: true
      },
      clients: {
        type: Array,
        required: true
      },
      currencies: {
        type: Array,
        required: true
      },
      loadingSelect: {
        type: Boolean,
        default: false
      },
      action: {
        type: String,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      endDateConfig () {
        return {
          minDate: moment(this.project.start_date).add(1, 'day').toDate(),
          dateFormat: "d M Y"
        }
      },
      startDateConfig () {
        return {
          maxDate: this.project.end_date ? moment(this.project.end_date).add(-1, 'day').toDate() : null,
          dateFormat: "d M Y"
        }
      }
    },
    methods: {
      async submit () {
        const isValid = await this.$refs.validator.validate();
        if (!isValid) return;
        this.$emit('confirm')
      },
      currencyChange (val) {
        this.project.currency = val;
      },
      fullManagerName ({name, surname}) {
        return `${name} ${surname}`
      },
      customCurrencyLabel (val) {
        return this.$t(`currencies.${val}`)
      }
    },
  }
</script>

<style lang="scss">
</style>
